export default {
  globe: require("../assets/tasks/globe.png"),
  fireIcon: require("../assets/svgs/fireIcon.svg"),
  filterIcon: require("../assets/tasks/filterIcon.png"),
  downArrow: require("../assets/tasks/downArrow.png"),
  one: [
    require("../assets/step1/one.svg"),
    require("../assets/step1/two.svg"),
    require("../assets/step1/nine.svg"),
    require("../assets/step1/four.svg"),
    require("../assets/step1/five.svg"),
    require("../assets/step1/six.svg"),
    require("../assets/step1/seven.svg"),
    require("../assets/step1/ten.svg"),
    require("../assets/step1/three.svg"),
    require("../assets/step1/eight.svg"),
  ],
  one_label: [
    "cool",
    "Intellectual",
    "Empathetic",
    "Geeky",
    "Funny",
    "Adventurous",
    "Reliable",
    "Creative",
    "Outgoing",
    "Confident",
  ],
  two: [
    require("../assets/step2/one.svg"),
    require("../assets/step2/two.svg"),
    require("../assets/step2/three.svg"),
    require("../assets/step2/four.svg"),
    require("../assets/step2/five.svg"),
    require("../assets/step2/six.svg"),
    require("../assets/step2/seven.svg"),
    require("../assets/step2/eight.svg"),
  ],
  two_label: [
    "Literature",
    "Sports",
    "Visual Arts",
    "Tech and Coding",
    "Culinary Arts",
    "Music",
    "Photography",
    "Puzzles",
  ],
  three_girl: [
    require("../assets/step3/girl_one.svg"),
    require("../assets/step3/girl_two.svg"),
    require("../assets/step3/girl_three.svg"),
    require("../assets/step3/girl_four.svg"),
    require("../assets/step3/girl_five.svg"),
    require("../assets/step3/girl_six.svg"),
  ],
  three_boy: [
    require("../assets/step3/boy_one.svg"),
    require("../assets/step3/boy_two.svg"),
    require("../assets/step3/boy_three.svg"),
    require("../assets/step3/boy_four.svg"),
    require("../assets/step3/boy_five.svg"),
    require("../assets/step3/boy_six.svg"),
  ],
};
